export const TYPY_ZATRUDNIENIA: Readonly<Record<string, string>> = {
  uop: 'Umowa o pracę',
  uz: 'Umowa zlecenie',
  ud: 'Umowa o dzieło',
  b2b: 'B2B',
};

export const FORMY_PRACY: Readonly<Record<string, string>> = {
  office: 'Stacjonarna',
  remote: 'Zdalna',
  hybrid: 'Hybrydowa',
  mobile: 'Mobilna',
};

export const WYMIARY_GODZINOWY: Readonly<Record<string, string>> = {
  100: 'Pełny etat',
  50: 'Pół etatu ',
  0: 'Praca nienormowana',
};

export const DOSWIADCZENIE: Readonly<Record<string, string>> = {
  trainee: 'Staż/praktyka',
  junior: 'Junior',
  mid: 'Specjalista',
  regular: 'Starszy specjalista',
  senior: 'Ekspert',
};

// List of components that will not be inside the container in Storybook
export const CONTAINER_BLACK_LIST = ['Newsletter', 'container', 'CategoriesTilesSection', 'AboutUsSection', 'IFrameBlok', 'PromoProduct'];

// The list of prefixes to be deleted from the URL
export const REMOVED_URL_PREFIXES = ['produkt/'];

// List of marketing routes to use in the sitemap
export const MARKETING_ROUTES:string[] = ['przedstawiciele-handlowi', 'kontakt/', 'adresy-sklepow/', 'kariera/'];

export const SB_LANGUAGES = {
  default: 'pl',
  en: 'en',
} as const;
